import { Flex, Box } from '@cad-arc';
import { EventSearchOptions, EventSearchStatics } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormInput } from '../forms/integrated-form-controls/form-input';
import { EventSearchFormTimeRangeFields } from './event-search-form-time-range-fields';
import { FormNInputs } from '../forms/integrated-form-controls/form-n-inputs';
import { EventSearchFormType } from './types';
import { useApplicationType } from '../common/hooks/use-application-type';

export function EventSearchFormPrimarySection({
    form,
    options,
    statics,
}: Readonly<{
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
    statics: EventSearchStatics;
}>) {
    const { isFirstResponder } = useApplicationType();
    return (
        <Flex flexFlow="wrap" gap="1rem">
            <Box>
                <FormNInputs
                    name="eventNumbers"
                    propertyName="eventNumber"
                    label="Event #"
                    buttonSize={isFirstResponder ? 'xl' : undefined}
                    control={form.control}
                />
            </Box>
            <Box>
                <FormNInputs
                    name="reportingEventNumbers"
                    propertyName="reportingEventNumber"
                    label={statics.reportingEventNumberDisplayName}
                    buttonSize={isFirstResponder ? 'xl' : undefined}
                    control={form.control}
                />
            </Box>

            <Box w="15rem">
                <FormInput
                    name="narrativeKeywords"
                    label="Narrative Keywords"
                    control={form.control}
                />
            </Box>

            <EventSearchFormTimeRangeFields form={form} options={options} />
        </Flex>
    );
}
